module.exports = __webpack_public_path__ + "static/media/yu.60f5b97e.jpeg";